import {
  Checkbox,
  Col,
  Form,
  Input,
  Radio,
  Row,
  Space,
  Typography,
} from "antd";
import React, { useEffect, useImperativeHandle, useRef, useState } from "react";
import "./TreatmentSheet.scss";

const catalogNDV = {
  xetNghiem: ["Huyết học", "Sinh hoá", "Vi sinh", "Nước tiểu"],
  CDHA: ["Chẩn đoán hình ảnh", "Khám bệnh"],
  dienTim: ["Điện tim"],
  PTTT: ["Phẫu thuật", "Thủ thuật", "Giường bệnh"],
};

const PrintContent = React.forwardRef((props, ref) => {
  const printRef = useRef<any>();
  const [data, setData] = useState<any>(null);
  const [toDieuTri, setToDieuTri] = useState<any>(null);
  const [rows, setRows] = useState<any>([]);
  useImperativeHandle(ref, () => ({
    setData: setData,
    getContentPrint: () => {
      setTimeout(() => {}, 5000);
      return printRef.current;
    },
  }));
  const [dichVus, setDichVus] = useState<any>([]);
  const [thuocs, setThuocs] = useState<any>([]);
  const getThuocs = (dts) => {
    let res = [];
    dts.map((it) => {
      res = [...res, ...it.thuocs];
    });
    return res;
  };
  const getDichVus = (dvs) => {
    let xnindex = 0;
    let cdhaindex = 0;
    let dientimindex = 0;
    let ptttindex = 0;
    let xn = [];
    let cdha = [];
    let dientim = [];
    let pttt = [];
    dvs.map((dt) => {
      xn = [
        ...xn,
        ...dt.nhomChiDinhDtos
          .filter((et) => catalogNDV.xetNghiem.includes(et.tenNhomChiDinh))
          .map((ft) => {
            let idx = xnindex;
            xnindex = xnindex + ft.chiDinhDtos.length;
            return { ...ft, index: idx };
          }),
      ];
      cdha = [
        ...cdha,
        ...dt.nhomChiDinhDtos
          .filter((et) => catalogNDV.CDHA.includes(et.tenNhomChiDinh))
          .map((ft) => {
            let idx = cdhaindex;
            cdhaindex = cdhaindex + ft.chiDinhDtos.length;
            return { ...ft, index: idx };
          }),
      ];
      dientim = [
        ...dientim,
        ...dt.nhomChiDinhDtos
          .filter((et) => catalogNDV.dienTim.includes(et.tenNhomChiDinh))
          .map((ft) => {
            let idx = dientimindex;
            dientimindex = dientimindex + ft.chiDinhDtos.length;
            return { ...ft, index: idx };
          }),
      ];
      pttt = [
        ...pttt,
        ...dt.nhomChiDinhDtos
          .filter((et) => catalogNDV.PTTT.includes(et.tenNhomChiDinh))
          .map((ft) => {
            let idx = ptttindex;
            ptttindex = ptttindex + ft.chiDinhDtos.length;
            return { ...ft, index: idx };
          }),
      ];
    });
    return {
      xetNghiem: xn,
      cdha: cdha,
      dientim: dientim,
      pttt: pttt,
    };
  };
  useEffect(() => {
    if (data) {
      data?.toDieuTri ? setToDieuTri(JSON.parse(data?.toDieuTri)) : null;
      setThuocs(getThuocs(data?.donThuocDtos ?? []));
      setDichVus(getDichVus(data?.phieuChiDinhDtos ?? []));
    }
  }, [data]);
  useEffect(() => {
    if (toDieuTri?.table) {
      let rs = [];
      Object.entries(toDieuTri.table).forEach(([key, value]) => {
        rs = [...rs, value];
      });
      setRows(rs);
    } else {
      setRows([]);
    }
  }, [toDieuTri]);
  useEffect(() => {}, [rows]);
  return (
    <div style={{ display: "none" }}>
      <div ref={printRef}>
        <div className="print-content">
          <Row style={{ margin: "24px 0" }}>
            <Col span={12}>
              <Row>
                <Typography.Text strong>BỘ Y TẾ</Typography.Text>
              </Row>
              <Row justify={"center"}>
                <Typography.Text strong>
                  BỆNH VIỆN CHUYÊN KHOA MẮT ALINA
                </Typography.Text>
              </Row>
            </Col>
            <Col span={8}></Col>
            <Col span={4}>
              <Row justify={"start"}>
                <Typography.Text>MS: 39/BV-01</Typography.Text>
              </Row>
              <Row justify={"start"}>
                <Typography.Text>Số vào viện:</Typography.Text>
              </Row>
            </Col>
          </Row>
          <Row justify={"center"}>
            <Typography.Title level={5}>TỜ ĐIỀU TRỊ</Typography.Title>
            <Row justify={"center"}>
              <Typography.Text>Số........</Typography.Text>
            </Row>
          </Row>
          <Row justify={"start"} style={{ marginBottom: "12px" }}>
            <Row>
              <Typography.Text>{`- Họ tên người bệnh:   ${
                toDieuTri?.hoTen ?? ""
              }`}</Typography.Text>
            </Row>
            <Row>
              <Col span={16}>
                <Typography.Text>{`- Tuổi: ${
                  toDieuTri?.tuoi ?? ""
                }`}</Typography.Text>
              </Col>
              <Col span={8}>
                <Typography.Text>{`Giới tính: ${
                  toDieuTri?.gioiTinh === 0 ? "Nam" : "Nữ"
                }`}</Typography.Text>
              </Col>
            </Row>
            <Row>
              <Typography.Text>{`- Địa chỉ:   ${
                toDieuTri?.diaChi ?? ""
              }`}</Typography.Text>
            </Row>
            <Row>
              <Col span={16}>
                <Typography.Text>{`- Khoa mắt tổng hợp:   ${
                  data?.khoaDieuTri ?? ""
                }`}</Typography.Text>
              </Col>
              <Col span={4}>
                <Typography.Text>{`Buồng:   ${
                  toDieuTri?.buong ?? ""
                }`}</Typography.Text>
              </Col>
              <Col span={4}>
                <Typography.Text>{`Giường:   ${
                  data?.giuong ?? ""
                }`}</Typography.Text>
              </Col>
            </Row>
            <Row>
              <Typography.Text>{`- Chẩn đoán:   ${
                toDieuTri?.chanDoan ?? ""
              }`}</Typography.Text>
            </Row>
          </Row>
          <Row>
            <Row align={"middle"}>
              <Col className="full-border d-flex-jcc" span={4}>
                <Typography.Text strong>NGÀY/GIỜ</Typography.Text>
              </Col>
              <Col className="full-border d-flex-jcc" span={10}>
                <Typography.Text strong>DIỄN BIẾN BỆNH</Typography.Text>
              </Col>
              <Col className="full-border d-flex-jcc" span={10}>
                <Typography.Text strong>Y LÊNH</Typography.Text>
              </Col>
            </Row>

            {rows.map((it, idx) => {
              return (
                <Row>
                  <Col span={4} className="full-border pdl-12">
                    <Typography.Text>{`${it.ngay ?? ""} - ${
                      it?.gio ?? ""
                    }`}</Typography.Text>
                  </Col>
                  <Col span={10} className="full-border pdl-12">
                    <Typography.Text>{`${
                      it?.dienBienBenh ?? ""
                    }`}</Typography.Text>
                  </Col>
                  <Col span={10} className="full-border pdl-12">
                    <Typography.Text>{`${it?.yLenh ?? ""}`}</Typography.Text>
                    {thuocs.map((dt) => {
                      return (
                        <Row>
                          <Typography.Text>{`+ ${dt.tenThuoc} x ${dt.soLuong} ${
                            dt.donVi
                          } ${dt.lieuDung ?? ""}`}</Typography.Text>
                        </Row>
                      );
                    })}
                    <Row>
                      <Typography.Text strong>CLS:</Typography.Text>
                    </Row>
                    <Row>
                      <Row>
                        <Typography.Text>{`+ XN:`}</Typography.Text>
                      </Row>
                      {dichVus.xetNghiem.map((dt) => {
                        return dt.chiDinhDtos.map((x) => {
                          return (
                            <Row>
                              <Typography.Text>{`${x.tenChiDinh} (${x.soLuong} lần)`}</Typography.Text>
                            </Row>
                          );
                        });
                      })}
                    </Row>
                    <Row>
                      <Row>
                        <Typography.Text>{`+ CĐHA:`}</Typography.Text>
                      </Row>
                      {dichVus.cdha.map((dt) => {
                        return dt.chiDinhDtos.map((x) => {
                          return (
                            <Row>
                              <Typography.Text>{`${x.tenChiDinh} (${x.soLuong} lần)`}</Typography.Text>
                            </Row>
                          );
                        });
                      })}
                    </Row>
                    <Row>
                      <Row>
                        <Typography.Text>{`+ Điện tim:`}</Typography.Text>
                      </Row>
                      {dichVus.dientim.map((dt) => {
                        return dt.chiDinhDtos.map((x) => {
                          return (
                            <Row>
                              <Typography.Text>{`${x.tenChiDinh} (${x.soLuong} lần)`}</Typography.Text>
                            </Row>
                          );
                        });
                      })}
                    </Row>
                    <Row>
                      <Row>
                        <Typography.Text>{`+ PT/TT:`}</Typography.Text>
                      </Row>
                      {dichVus.pttt.map((dt) => {
                        return dt.chiDinhDtos.map((x) => {
                          return (
                            <Row>
                              <Typography.Text>{`${x.tenChiDinh} (${x.soLuong} lần)`}</Typography.Text>
                            </Row>
                          );
                        });
                      })}
                    </Row>
                  </Col>
                </Row>
              );
            })}

            {/* <Row justify={'space-between'} style={{marginTop: "12px", marginRight: "24px"}}>
            <Col></Col>
            <Col>
              <Row justify={'center'}>
                <Typography.Text>{`Ngày ${dayjs().day()} tháng ${dayjs().month()} năm ${dayjs().year()}`}</Typography.Text>
              </Row>
              <Row justify={'center'}>
                <Typography.Title level={5} style={{marginTop: "0"}}>BÁC SĨ KHÁM BỆNH</Typography.Title>
              </Row>
              <Row justify={'center'} style={{marginTop: "36px"}}>
                <Typography.Text strong>{localStorage.getItem("fullName") ?? ""}</Typography.Text>
              </Row>
            </Col>
          </Row> */}
          </Row>
        </div>
      </div>
    </div>
  );
});

export default PrintContent;
